import { FC } from 'react';
import styles from './index.module.less';
import { Col, Row } from 'antd';
import Card from './Card';

/**
 * @Description 小区行，一行两个卡片
 */
const ListItem:FC<{
  row: any[];
  curDetail: any;
  setCurDetail: any;
}> = ({
  row = [],
  curDetail,
  setCurDetail
}) => {
  return (
    <div className={styles.listItemCon}>
      <Row gutter={[8, 10]}>
        {
          row.map((item, index) => {
            return <Col key={`${item.name}_${index}`} span={12}>
              <Card key={`${item.name}_${index}`} data={item} curDetail={curDetail} setCurDetail={setCurDetail} />
            </Col>;
          })
        }
      </Row>
    </div>
  );
};


export default ListItem;
